class EmailAnalyticsService {
    constructor($q, $http, ICM_EMAIL_API_URL) {
        this.$q = $q;
        this.$http = $http;

        this.aggregationUrl = ICM_EMAIL_API_URL + '/engagement/aggregation';
        this.analyticsUrl = ICM_EMAIL_API_URL + '/analytics';
    }

    getCompanyAggregations() {
        return this.$http.get(this.aggregationUrl).then((response) => {
            return response.data;
        });
    }

    getMediaListAggregations(mediaListId) {
        return this.getMediaListsAggregations([mediaListId]).then((response) => {
            return response[mediaListId];
        });
    }

    getMediaListsAggregations(mediaListIds) {
        let payload = {
            mediaListIds: mediaListIds
        };

        return this.$http.post(`${this.aggregationUrl}/mediaLists`, payload).then((response) => {
            return response.data;
        });
    }

    getStatsCount(distributionId, statisticsType) {
        return this.$http.get(this.analyticsUrl + '/distributions/' + distributionId + '/' + statisticsType + '/count').then((response) => {
            return response.data;
        });
    }

    getStatsContacts(distributionId, statisticsType, subType) {
        let query = {
          page: 0,
          pageSize: 25,
          stat: subType ? subType : 'all'
        };
        return this.$http.post(this.analyticsUrl + '/distributions/' + distributionId + '/' + statisticsType + '/recipients', query).then((response) => {
            return response.data;
        })
        .catch(() => {
            return [];
        });
    }

}

angular
    .module('MW.Influencers.EmailAnalyticsService', [
        'Configuration',
    ])
    .service('EmailAnalyticsService', [
        '$q',
        '$http',
        'ICM_EMAIL_API_URL',
        EmailAnalyticsService
    ]);
